import times from 'lodash/times';
import React from 'react';
import { Box } from '../../../../../../../CommonComponents/OPL/Box/Box';
import { Card } from '../../../../../../../CommonComponents/OPL/Card/Card';
import { Shimmer } from '../../../../../../../CommonComponents/OPL/Shimmer/Shimmer';
import { Text } from '../../../../../../../CommonComponents/OPL/Text/Text';

interface TotalsLoadingProps {
  isEmbeddedMobile: boolean;
  title: string;
}

export const TotalsLoading = ({ isEmbeddedMobile, title }: TotalsLoadingProps) => {
  const mobileBorderLayout = {
    bordeTop: '1px solid',
    borderBottom: '1px solid',
    borderColor: 'neutral.200',
  };

  const dektopBorderLayout = {
    borderLeft: '1px solid',
    borderRight: '1px solid',
    borderColor: 'neutral.200',
  };

  return (
    <>
      <Box {...(isEmbeddedMobile ? { mt: '24' } : {})}>
        <Card hasBorder boxShadow="none" {...(isEmbeddedMobile ? { borderRadius: 'none' } : {})}>
          <Box p="12" borderBottom="1px solid" borderColor="neutral.200">
            <Text fontSize="h6" fontWeight={600}>
              {title}
            </Text>
          </Box>
          <Box display="flex" {...(isEmbeddedMobile ? { flexDirection: 'column' } : {})}>
            {times(3).map((key, index) => (
              <Box
                key={key}
                p="24"
                display="flex"
                flexDirection="column"
                flex={1}
                {...(index === 1
                  ? isEmbeddedMobile
                    ? mobileBorderLayout
                    : dektopBorderLayout
                  : {})}
              >
                <Shimmer
                  width="100%"
                  mb="4"
                  {...(isEmbeddedMobile ? { height: '12px' } : { height: '16px' })}
                />

                <Shimmer
                  width="100%"
                  {...(isEmbeddedMobile ? { height: '20px' } : { height: '48px' })}
                />
              </Box>
            ))}
          </Box>
        </Card>
      </Box>
    </>
  );
};
